import * as React from 'react';
import {
  Datagrid,
  DateField,
  List,
  SimpleShowLayout,
  TextField,
  BooleanField,
  TextInput, required,
  BooleanInput,
} from "react-admin";
import EditView from "../../../components/EditView";
import CreateView from "../../../components/CreateView";
import ShowView from "../../../components/ShowView";

import { ColorField, ColorInput } from 'react-admin-color-input';
import { SvgIcon } from '@mui/material';

export const StatusCallList = (props) => (

  <List {...props} sort={{ field: 'createdAt', order: 'ASC' }} >
    <Datagrid rowClick="edit">
      <TextField source="title" label="عنوان" />
      <BooleanField source="isDefault" FalseIcon={SvgIcon} label="پیشفرض شروع " />
      <BooleanField source="isEnd" FalseIcon={SvgIcon} label="پیشفرض پایان سرنخ" />
      <DateField locales={"fa-IR"} source="updatedAt" />
      <ColorField source="stColor" label="رنگ سرنخ" />

    </Datagrid>
  </List>
);

export const StatusCallEdit = (props) => (
  <EditView {...props} perPage={10}>
    <TextInput source="title" validate={required()} />
    <BooleanInput source="isDefault" label="پیشفرض شروع" />
    <BooleanInput source="isEnd" label="پیشفرض پایان سرنخ" />
    <ColorInput source="stColor" label="رنگ سرنخ" />
  </EditView>
);

export const StatusCallShow = (props) => (
  <ShowView {...props}>
    <SimpleShowLayout>
      <TextField source="title" />
      <BooleanField source="isDefault" FalseIcon={SvgIcon} label="پیشفرض شروع " />
      <BooleanField source="isEnd" FalseIcon={SvgIcon} label="پیشفرض پایان سرنخ" />
      <DateField locales={"fa-IR"} source="createdAt" />
      <DateField locales={"fa-IR"} source="updatedAt" />
      <TextField source="objectId" />
      <ColorField source="stColor" label="رنگ سرنخ" />

    </SimpleShowLayout>
  </ShowView>
);

export const StatusCallCreate = (props) => (
  <CreateView {...props}>
    <TextInput source="title" label="عنوان" />
    <BooleanInput source="isDefault" label="پیشفرض شروع" />
    <BooleanInput source="isEnd" label="پیشفرض پایان سرنخ" />
    <ColorInput source="stColor" label="رنگ سرنخ" />
  </CreateView>
);
